import React from 'react';
import SimpleAccordion from './Acc';
import './ReturnPolicy.css';
import Fade from 'react-reveal/Fade';


function ReturnPolicy() {
    return (
        <div className="return">
            <Fade bottom>
            <h3 className="return_title">Our return policy</h3>
            <div className="return_para">
                <p>You can initiate a return within 15 days for eligible items; 
                    if you receive a wrong, damaged, defective or counterfeit item. 
                    For change of mind (with seal intact), ensure to report/return 
                    on the spot during delivery/ pick up or within 24 hrs of delivery 
                    for your return to be valid</p>
                <p>When returning an item, ensure all seals, tags and accessories are 
                    left intact and item is in its original packaging. If you have 
                    created a password on the device you wish to return, please 
                    ensure it is removed, otherwise, your return will be invalid.</p>
                <img className="return_img" src={window.location.origin +'/return.jpg'} alt="return policy"/>
            </div>
            <div className="accordion">
                <h3 className="return_title">Frequently Asked Questions</h3>
                <SimpleAccordion/>
            </div>
            </Fade>
        </div>
    )
}

export default ReturnPolicy;
